






















import TheG01Content from "@/general/components/pages/parts/Ranking/TheG01Content.vue";
import G01ItemListGroup from "@/general/components/pages/parts/Ranking/G01ItemListGroup.vue";
import { Vue, Component } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import items from "@/general/store/modules/items";
import { rankingByCategory } from "@/general/store/api";

@Component({
  components: {
    TheG01Content,
    G01ItemListGroup
  }
})
export default class TheG01ContentCategory extends Vue {
  rankingCategory: any = [];

  get categories() {
    return this.rankingCategory;
  }
  async created() {
    this.rankingCategory = await rankingByCategory();
  }
}
